import { BpmnModelJsonHelper } from '@edp-bif/common-api';
import { RtShowEntity } from './RtShowEntity';

export class RtShowEntitiesWithCustomization extends RtShowEntity {
    isEnabled: boolean;
    customizationEntities: Array<RtShowEntitiesWithCustomization> = new Array();

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.isEnabled = false;
        this.customizationEntities.length = 0;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "isEnabled", this.isEnabled);
        BpmnModelJsonHelper.SetAttributeValue(obj, "customizationEntities", this.customizationEntities);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.isEnabled = BpmnModelJsonHelper.GetAttributeValueAsBoolean(obj, "isEnabled");
        this.customizationEntities = BpmnModelJsonHelper.GetAttributeValueAsList(obj, "customizationEntities", RtShowEntitiesWithCustomization);
    }

    protected getTClass() {
        return RtShowEntitiesWithCustomization;
    }
}